import '../../../../lib/trigger/style';
